import React from 'react'
import usePrescriptionStore from '../DataRepository/Prescription';
import { IconButton, Button } from '@mui/material';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import PauseIcon from '@mui/icons-material/Pause';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { useEffect, useState, useRef } from 'react'
import axios from 'axios'
import aiwelllogo from '../Assets/images/Aiwell Logo 1 1.png'
import DownloadIcon from '@mui/icons-material/Download';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, MenuItem, TextField, Slider } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import {
    kioskModel,
    profileModel
} from "../Axios/AxiosConfig";
import ReportStore from '../DataRepository/Reports';

const initBeforeUnLoad = (showExitPrompt) => {
    window.onbeforeunload = (event) => {
        if (showExitPrompt) {
            const e = event || window.event;
            e.preventDefault();
            if (e) {
                e.returnValue = "";
            }
            return "";
        }
    };
};

function ViewPrescription() {
    const { selectedPrescription, setPrescription } = usePrescriptionStore()
    const { getAIReports, aiParameters, setAiParameters } = ReportStore()
    const [showExitPrompt, setShowExitPrompt] = useState(true);
    const [prescriptionOneData, setPrescriptionOneData] = useState(null);

    const doctorDetailsCookie = Cookies.get("Doctor_details");
    let Doctor_details = {};
    try {
        if (doctorDetailsCookie) {
            Doctor_details = JSON.parse(doctorDetailsCookie);
        }
    } catch (error) {
        console.log("Error parsing Doctor_details cookie:", error);
    }

    window.onload = function () {
        initBeforeUnLoad(showExitPrompt);
    };


    const audioRef = useRef(null);

    const [isPlaying, setIsPlaying] = useState(false);

    const handlePlayPause = () => {
        const audio = audioRef.current;
        if (isPlaying) {
            audio.pause();
        } else {
            audio.play();
        }
        setIsPlaying(!isPlaying);
    };

    useEffect(() => {
        initBeforeUnLoad(showExitPrompt);
        window.scrollTo(0, 0);
        return () => {
            window.onbeforeunload = null;
        };
    }, [showExitPrompt]);

    const handleDownload = (s3Link, name) => {
        if (!s3Link) {
            alert("Prescription document is not available yet.");
            return;
        }

        console.log("Opening Prescription from URL:", s3Link);
        // Open directly in a new tab synchronously to bypass popup blockers and CORS
        window.open(s3Link, '_blank');
    };

    const navigate = useNavigate()

    const ratings = ["None", "Mild", "Moderate", "High", "Severe", "Extreme"];
    const headerStyle = {
        fontFamily: "'Poppins', sans-serif",
        fontWeight: 500,
        color: "black",
        fontSize: "16px",
        padding: "10px"
    };

    const cellStyle = {
        fontFamily: "'Poppins', sans-serif",
        fontWeight: 400,
        color: "black",
        fontSize: "15px",
        padding: "10px"
    };

    useEffect(() => {
        if (!selectedPrescription) {
            return;
        }

        const UID = selectedPrescription?.PatientID || selectedPrescription?.Patient_details?.UID || selectedPrescription?.Patient_details?.uid;
        const id = selectedPrescription?.id;

        if (!UID || !id) {
            console.log("Missing UID or id for prescription fetching", { UID, id });
            return;
        }

        const fetchPrescription = async () => {
            try {
                const res = await kioskModel.post("/api/v1/getOnePrescription", {
                    UID,
                    id,
                });

                if (res.status === 200) {
                    console.log(res.data, "prescription data..")
                    setPrescriptionOneData(res.data);

                    // Fallback for AI Reports if not present in prescription data
                    if (!res.data.AI_Reports || res.data.AI_Reports.length === 0) {
                        getAIReports(
                            UID,
                            selectedPrescription.Appointment_details.id || selectedPrescription.Appointment_details._id
                        );
                    } else {
                        setAiParameters([]); // Clear if already present in prescription
                    }
                }

            } catch (err) {
                console.error("Error fetching prescription data:", err);
            }
        };

        fetchPrescription();
    }, [selectedPrescription?.id, selectedPrescription?.Appointment_details?.UID]);

    const vitalSignMeta = {
        bloodPressure: { label: "Blood Pressure", unit: "mmHg" },
        pulseRate: { label: "Pulse Rate", unit: "bpm" },
        respiratoryRate: { label: "Respiratory Rate", unit: "breaths/min" },
        randomBloodSugar: { label: "Blood Sugar", unit: "mg/dL" },
        oximeterValue: { label: "Oximeter Value", unit: "%" },
        temperature: { label: "Temperature", unit: "°F" },
        weight: { label: "Weight", unit: "kg" },
        height: { label: "Height", unit: "cm" },
        bmi: { label: "BMI", unit: "kg/m²" }
    };

    const doshaMap = {
        V: "Vata",
        P: "Pitta",
        K: "Kapha"
    };

    function isDoshamEmpty(dosham) {

        const isEmptyArray = (arr) => Array.isArray(arr) && arr.length === 0;
        const isEmptyObject = (obj) => obj && Object.keys(obj).length === 0;

        return (
            isEmptyArray(dosham.Increased.doshas) &&
            isEmptyObject(dosham.Increased.percentage) &&
            isEmptyObject(dosham.Increased.intensity) &&
            isEmptyArray(dosham.Decreased.doshas) &&
            isEmptyObject(dosham.Decreased.percentage) &&
            isEmptyObject(dosham.Decreased.intensity)
        );
    }

    function hasFamilyHistoryDetails(familyHistory) {
        return familyHistory.some(entry => {
            return (entry.disease && entry.disease.trim() !== '') ||
                (entry.duration && entry.duration.trim() !== '');
        });
    };

    function hasCurrentDrugsDetails(currentDrugs) {
        return currentDrugs.some(entry => {
            return (entry.medicine && entry.medicine.trim() !== '') ||
                (entry.dose && entry.dose.trim() !== '') ||
                (entry.duration && entry.duration.trim() !== '');
        });
    };


    const MEAL_ORDER = ["breakfast", "mid-day-snack", "lunch", "snack", "dinner"];

    const MEAL_LABELS = {
        "breakfast": "Breakfast",
        "mid-day-snack": "Mid-day snack",
        "lunch": "Lunch",
        "snack": "Snack",
        "dinner": "Dinner",
    };

    const normalizeMeal = (val = "") => {
        const s = String(val).toLowerCase().replace(/_/g, "-").replace(/\s+/g, "-");
        if (MEAL_ORDER.includes(s)) return s;
        if (/mid/.test(s) && /snack/.test(s)) return "mid-day-snack";
        if (/break/.test(s)) return "breakfast";
        if (/lunch/.test(s)) return "lunch";
        if (/dinner/.test(s)) return "dinner";
        if (/snack/.test(s)) return "snack";
        return "snack"; // default bucket
    };

    const groupedRecipes = React.useMemo(() => {
        const acc = Object.fromEntries(MEAL_ORDER.map(k => [k, []]));
        (prescriptionOneData?.Recipes ?? []).forEach(r => {
            const key = normalizeMeal(r.time ?? r.mealType ?? r.slot);
            acc[key].push(r);
        });
        // optional: sort each group by recipe name
        MEAL_ORDER.forEach(k => acc[k].sort((a, b) => (a.recipe || "").localeCompare(b.recipe || "")));
        return acc;
    }, [prescriptionOneData?.Recipes]);

    return <div className='Reports-main-page'>
        <div className='Reports-text-box'>
            <div className='flex flex-row justify-between items-center m-2'>

                <div className='flex items-center gap-4'>
                    <Button
                        startIcon={<ArrowBackIcon />}
                        style={{
                            textTransform: 'none',
                            color: '#DA6E0B',
                            fontFamily: "'Poppins', sans-serif",
                            fontWeight: 500
                        }}
                        onClick={() => navigate("/Precription")}
                    >
                        All Prescriptions
                    </Button>

                    <Button
                        startIcon={<AccountCircleIcon />}
                        style={{
                            textTransform: 'none',
                            color: '#DA6E0B',
                            fontFamily: "'Poppins', sans-serif",
                            fontWeight: 500
                        }}
                        onClick={() => {
                            const patientUID = prescriptionOneData?.PatientID || prescriptionOneData?.Patient_details?.UID || prescriptionOneData?.Patient_details?.uid || selectedPrescription?.PatientID || selectedPrescription?.Patient_details?.UID || selectedPrescription?.Patient_details?.uid;
                            if (patientUID) {
                                navigate(`/Patient/${patientUID}`);
                            }
                        }}
                    >
                        Patient Profile
                    </Button>
                </div>

                <p style={{
                    fontFamily: "'Poppins', sans-serif",
                    fontWeight: 600,
                    color: "black"
                }}>{prescriptionOneData?.Date ? new Date(prescriptionOneData.Date).toLocaleDateString('en-GB', { day: '2-digit', month: 'long', year: 'numeric' }) : ""}</p>

                <div className='flex items-center gap-4'>
                    {prescriptionOneData?.Audio_Prescription &&
                        <div className='flex items-center'>
                            <audio ref={audioRef}>
                                <source src={prescriptionOneData?.Audio_Prescription} type="audio/mpeg" />
                                Your browser does not support the audio element.
                            </audio>
                            <IconButton onClick={handlePlayPause} style={{ color: "#DA6E0B" }}>
                                {isPlaying ? <PauseIcon /> : <PlayArrowIcon />}
                            </IconButton>
                            <p style={{ fontSize: '12px', color: '#666' }}>Audio Prescription</p>
                        </div>
                    }

                    <Button style={{
                        textTransform: 'none',
                        backgroundColor: '#DA6E0B',
                        color: 'white',
                        borderRadius: '5px',
                        fontFamily: "'Poppins', sans-serif",
                        fontWeight: 500,
                        padding: '8px 20px'
                    }} onClick={() => {
                        setPrescription(prescriptionOneData)
                        navigate("/prescription");
                    }}>
                        Edit
                    </Button>
                </div>
            </div>

            <div className=''  >
                <div>
                    <div className="header">
                        <img
                            src={aiwelllogo}
                            alt="Aiwell Logo"
                        />
                        <div className="prescription-doctor-details" style={{ color: 'black' }}>
                            <p>{prescriptionOneData?.Doctor_details?.name || Doctor_details?.name} &nbsp;
                                <span style={{ fontSize: "12px" }}>{prescriptionOneData?.Doctor_details?.course_details || Doctor_details?.course_details}</span></p>
                            <p style={{ fontSize: "12px" }}>
                                Register No: {prescriptionOneData?.Doctor_details?.regno || Doctor_details?.regno}</p>
                            <p >{prescriptionOneData?.Doctor_details?.speciality || Doctor_details?.speciality}</p>
                            <p >Ayurvedic Physician</p>
                        </div>
                    </div>

                    <div className="prescription-container p-5">

                        <div>
                            <p className="Prescription-sh-h">Patient Details</p>
                            <div className="Patient-details">
                                <div className='flex items-center gap-2'>
                                    <p>Name:</p>
                                    <p>
                                        {prescriptionOneData?.Patient_details?.firstname}{" "}
                                        {prescriptionOneData?.Patient_details?.lastname}
                                    </p>
                                </div>

                                <div className='flex items-center gap-2'>
                                    <p>Age:</p>
                                    <p>{prescriptionOneData?.Patient_details?.dob}</p>
                                </div>

                                <div className='flex items-center gap-2'>
                                    <p>Gender:</p>
                                    <p>{prescriptionOneData?.Patient_details?.gender}</p>
                                </div>

                                {prescriptionOneData?.Patient_details?.height && (
                                    <div className='flex items-center gap-2'>
                                        <p>Height:</p>
                                        <p>
                                            {prescriptionOneData?.Patient_details?.height_unit === "ft"
                                                ? `${prescriptionOneData?.Patient_details?.height_ft}'${prescriptionOneData?.Patient_details?.height_in}"`
                                                : `${prescriptionOneData?.Patient_details?.height} ${prescriptionOneData?.Patient_details?.height_unit || "cm"}`
                                            }
                                        </p>
                                    </div>
                                )}

                                {(prescriptionOneData?.Patient_details?.weight_kg || prescriptionOneData?.Patient_details?.weight_lbs) && (
                                    <div className='flex items-center gap-2'>
                                        <p>Weight:</p>
                                        <p>
                                            {prescriptionOneData?.Patient_details?.weight_unit === "lbs"
                                                ? `${prescriptionOneData?.Patient_details?.weight_lbs || ""} lbs`
                                                : `${prescriptionOneData?.Patient_details?.weight_kg || ""} kg`}
                                        </p>
                                    </div>
                                )}

                                {prescriptionOneData?.Patient_details?.bmi && (
                                    <div className='flex items-center gap-2'>
                                        <p>BMI:</p>
                                        <p>{prescriptionOneData?.Patient_details?.bmi} kg/m²</p>
                                    </div>
                                )}

                            </div>

                        </div>

                        {prescriptionOneData?.ChiefComplaints && prescriptionOneData?.ChiefComplaints.length > 0 &&
                            <div>
                                <p className="Prescription-sh-h">Chief Complaints</p>
                                <div style={{ padding: '1rem' }}>
                                    <TableContainer>
                                        <Table aria-label="symptoms table">
                                            <TableHead style={{ backgroundColor: "#D4CEC3" }}>
                                                <TableRow>
                                                    <TableCell sx={{ width: '30%' }} align="center"
                                                        style={{
                                                            fontFamily: "'Poppins', sans-serif",
                                                            fontWeight: 500,
                                                            color: "black",
                                                            fontSize: "16px",
                                                            padding: "10px"
                                                        }}>Symptom</TableCell>
                                                    <TableCell sx={{ width: '40%' }} align="center" style={{
                                                        fontFamily: "'Poppins', sans-serif",
                                                        fontWeight: 500,
                                                        color: "black",
                                                        fontSize: "16px",
                                                        padding: "10px"
                                                    }}>Severity</TableCell>
                                                    <TableCell sx={{ width: '30%' }} align="center"
                                                        style={{
                                                            fontFamily: "'Poppins', sans-serif",
                                                            fontWeight: 500,
                                                            color: "black",
                                                            fontSize: "16px",
                                                            padding: "10px"
                                                        }}>Duration</TableCell>
                                                    <TableCell sx={{ width: '30%' }} align="center"
                                                        style={{
                                                            fontFamily: "'Poppins', sans-serif",
                                                            fontWeight: 500,
                                                            color: "black",
                                                            fontSize: "16px",
                                                            padding: "10px"
                                                        }}>Frequency</TableCell>
                                                    <TableCell sx={{ width: '30%' }} align="center"
                                                        style={{
                                                            fontFamily: "'Poppins', sans-serif",
                                                            fontWeight: 500,
                                                            color: "black",
                                                            fontSize: "16px",
                                                            padding: "10px"
                                                        }}>Goal</TableCell>
                                                    <TableCell sx={{ width: '10%' }} align="center"></TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody style={{ backgroundColor: "#F8F8F4" }}>
                                                {prescriptionOneData?.ChiefComplaints?.map((e, i) => (
                                                    <TableRow key={i}>
                                                        <TableCell component="th" scope="row" sx={{ width: '30%' }}>
                                                            <p style={{
                                                                fontFamily: "'Poppins', sans-serif",
                                                                fontWeight: 500,
                                                                color: "black",
                                                                fontSize: "16px",
                                                            }}>{e?.symptoms}</p>
                                                        </TableCell>
                                                        <TableCell sx={{ width: '40%' }}>
                                                            <div className="flex items-center justify-center space-x-6">
                                                                {ratings?.map((label, index) => (
                                                                    <div
                                                                        key={index}
                                                                        className="flex flex-col items-center cursor-pointer"
                                                                    >
                                                                        <div
                                                                            className={`w-6 h-6 rounded-full transition-all duration-300 ${e?.severity >= index ? "bg-[#DA6E0B]" : "bg-gray-300"
                                                                                }`}
                                                                        ></div>
                                                                        <span className="mt-2 text-sm text-black" style={{
                                                                            fontFamily: "'Poppins', sans-serif",
                                                                            fontWeight: 400,
                                                                        }}>{label}</span>
                                                                    </div>
                                                                ))}

                                                                {/* <p style={{
                                                                    fontFamily: "'Poppins', sans-serif",
                                                                    fontWeight: 500,
                                                                    color: "black",
                                                                    fontSize: "16px",
                                                                }}>{ratings[e?.severity]}</p> */}

                                                            </div>
                                                        </TableCell>
                                                        <TableCell align="center" sx={{ width: '30%' }}>
                                                            <p style={{
                                                                fontFamily: "'Poppins', sans-serif",
                                                                fontWeight: 500,
                                                                color: "black",
                                                                fontSize: "16px",
                                                            }}>{e?.duration}</p>
                                                        </TableCell>
                                                        <TableCell align="center" sx={{ width: '30%' }}>
                                                            <p style={{
                                                                fontFamily: "'Poppins', sans-serif",
                                                                fontWeight: 500,
                                                                color: "black",
                                                                fontSize: "16px",
                                                            }}>{e?.frequeny}</p>
                                                        </TableCell>
                                                        <TableCell align="center" sx={{ width: '30%' }}>
                                                            <input
                                                                type="checkbox"
                                                                checked={e?.goal}
                                                                readOnly
                                                                onClick={(e) => e.preventDefault()}
                                                                style={{
                                                                    width: '16px',
                                                                    height: '16px',
                                                                    accentColor: '#DA6E0B',
                                                                    cursor: 'default',
                                                                }}
                                                            />
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </div>
                            </div>
                        }

                        {prescriptionOneData?.PastHistory && prescriptionOneData?.PastHistory?.length > 0 &&
                            < div >
                                <p className="Prescription-sh-h">Past History</p>
                                <div style={{ padding: '1rem' }}>
                                    <TableContainer>
                                        <Table aria-label="symptoms table">
                                            <TableHead style={{ backgroundColor: "#D4CEC3" }}>
                                                <TableRow>
                                                    <TableCell sx={{ width: '30%' }} align="center"
                                                        style={{
                                                            fontFamily: "'Poppins', sans-serif",
                                                            fontWeight: 500,
                                                            color: "black",
                                                            fontSize: "16px",
                                                            padding: "10px"
                                                        }}>Ayurveda Disease</TableCell>
                                                    <TableCell sx={{ width: '30%' }} align="center"
                                                        style={{
                                                            fontFamily: "'Poppins', sans-serif",
                                                            fontWeight: 500,
                                                            color: "black",
                                                            fontSize: "16px",
                                                            padding: "10px"
                                                        }}>Modern Disease</TableCell>
                                                    <TableCell sx={{ width: '40%' }} align="center" style={{
                                                        fontFamily: "'Poppins', sans-serif",
                                                        fontWeight: 500,
                                                        color: "black",
                                                        fontSize: "16px",
                                                        padding: "10px"
                                                    }}>Severity</TableCell>
                                                    <TableCell sx={{ width: '30%' }} align="center"
                                                        style={{
                                                            fontFamily: "'Poppins', sans-serif",
                                                            fontWeight: 500,
                                                            color: "black",
                                                            fontSize: "16px",
                                                            padding: "10px"
                                                        }}>Duration</TableCell>

                                                    <TableCell sx={{ width: '10%' }} align="center"></TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody style={{ backgroundColor: "#F8F8F4" }}>
                                                {prescriptionOneData?.PastHistory?.map((e, i) => (
                                                    <TableRow key={i}>
                                                        <TableCell component="th" scope="row" sx={{ width: '30%' }}>
                                                            <p style={{
                                                                fontFamily: "'Poppins', sans-serif",
                                                                fontWeight: 500,
                                                                color: "black",
                                                                fontSize: "16px",
                                                            }}>{e?.ayurvedaDisease}</p>
                                                        </TableCell>
                                                        <TableCell component="th" scope="row" sx={{ width: '30%' }}>
                                                            <p style={{
                                                                fontFamily: "'Poppins', sans-serif",
                                                                fontWeight: 500,
                                                                color: "black",
                                                                fontSize: "16px",
                                                            }}>{e?.modernDisease}</p>
                                                        </TableCell>
                                                        <TableCell sx={{ width: '40%' }}>
                                                            <div className="flex items-center justify-center space-x-6">
                                                                {ratings?.map((label, index) => (
                                                                    <div
                                                                        key={index}
                                                                        className="flex flex-col items-center cursor-pointer"
                                                                    >
                                                                        <div
                                                                            className={`w-6 h-6 rounded-full transition-all duration-300 ${e?.severity >= index ? "bg-[#DA6E0B]" : "bg-gray-300"
                                                                                }`}
                                                                        ></div>
                                                                        <span className="mt-2 text-sm text-black" style={{
                                                                            fontFamily: "'Poppins', sans-serif",
                                                                            fontWeight: 400,
                                                                        }}>{label}</span>
                                                                    </div>
                                                                ))}

                                                                {/* <p style={{
                                                                    fontFamily: "'Poppins', sans-serif",
                                                                    fontWeight: 500,
                                                                    color: "black",
                                                                    fontSize: "16px",
                                                                }}>{ratings[e?.severity]}</p> */}

                                                            </div>
                                                        </TableCell>
                                                        <TableCell align="center" sx={{ width: '30%' }}>
                                                            <p style={{
                                                                fontFamily: "'Poppins', sans-serif",
                                                                fontWeight: 500,
                                                                color: "black",
                                                                fontSize: "16px",
                                                            }}>{e?.duration}</p>
                                                        </TableCell>


                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </div>
                            </div>
                        }

                        {prescriptionOneData?.familyHistory && hasFamilyHistoryDetails(prescriptionOneData?.familyHistory) &&
                            < div >
                                <p className="Prescription-sh-h">Family History</p>
                                <div style={{ padding: '1rem' }}>
                                    <TableContainer>
                                        <Table aria-label="symptoms table">
                                            <TableHead style={{ backgroundColor: "#D4CEC3" }}>
                                                <TableRow>
                                                    <TableCell sx={{ width: '30%' }} align="center"
                                                        style={{
                                                            fontFamily: "'Poppins', sans-serif",
                                                            fontWeight: 500,
                                                            color: "black",
                                                            fontSize: "16px",
                                                            padding: "10px"
                                                        }}>Relation</TableCell>
                                                    <TableCell sx={{ width: '30%' }} align="center"
                                                        style={{
                                                            fontFamily: "'Poppins', sans-serif",
                                                            fontWeight: 500,
                                                            color: "black",
                                                            fontSize: "16px",
                                                            padding: "10px"
                                                        }}>Disease</TableCell>

                                                    <TableCell sx={{ width: '30%' }} align="center"
                                                        style={{
                                                            fontFamily: "'Poppins', sans-serif",
                                                            fontWeight: 500,
                                                            color: "black",
                                                            fontSize: "16px",
                                                            padding: "10px"
                                                        }}>Duration</TableCell>

                                                    <TableCell sx={{ width: '10%' }} align="center"></TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody style={{ backgroundColor: "#F8F8F4" }}>
                                                {prescriptionOneData?.familyHistory?.map((e, i) => (
                                                    <TableRow key={i}>
                                                        <TableCell component="th" scope="row" sx={{ width: '30%' }} align="center">
                                                            <p style={{
                                                                fontFamily: "'Poppins', sans-serif",
                                                                fontWeight: 500,
                                                                color: "black",
                                                                fontSize: "16px",
                                                            }}>{e?.relation}</p>
                                                        </TableCell>
                                                        <TableCell component="th" scope="row" sx={{ width: '30%' }} align="center">
                                                            <p style={{
                                                                fontFamily: "'Poppins', sans-serif",
                                                                fontWeight: 500,
                                                                color: "black",
                                                                fontSize: "16px",
                                                            }}>{e?.disease}</p>
                                                        </TableCell>

                                                        <TableCell align="center" sx={{ width: '30%' }}>
                                                            <p style={{
                                                                fontFamily: "'Poppins', sans-serif",
                                                                fontWeight: 500,
                                                                color: "black",
                                                                fontSize: "16px",
                                                            }}>{e?.duration}</p>
                                                        </TableCell>


                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </div>
                            </div>
                        }

                        {prescriptionOneData?.MenstrualDetails && Object.keys(prescriptionOneData?.MenstrualDetails).length > 0 && (
                            <div>
                                <p className="Prescription-sh-h">Menstruation / Obstetrical</p>
                                <div className="Patient-details">
                                    {Object.entries(prescriptionOneData?.MenstrualDetails).map(([key, val]) => (
                                        <div key={key} className="flex items-center gap-2">
                                            <p className="font-semibold text-[#DA6E0B]">
                                                {key?.replace(/([A-Z])/g, ' $1')?.replace(/^./, str => str?.toUpperCase())}:
                                            </p>
                                            <p>
                                                {typeof val === 'object'
                                                    ? `${val?.answer || ''}${val?.details ? ` - ${val?.details}` : ''}`
                                                    : val}
                                            </p>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}


                        {prescriptionOneData?.currentDrugs && hasCurrentDrugsDetails(prescriptionOneData?.currentDrugs) && (
                            <div>
                                <p className="Prescription-sh-h">Current Drugs</p>
                                <div style={{ padding: '1rem' }}>
                                    <TableContainer>
                                        <Table aria-label="symptoms table">
                                            <TableHead style={{ backgroundColor: "#D4CEC3" }}>
                                                <TableRow>
                                                    <TableCell sx={{ width: '30%' }} align="center"
                                                        style={{
                                                            fontFamily: "'Poppins', sans-serif",
                                                            fontWeight: 500,
                                                            color: "black",
                                                            fontSize: "16px",
                                                            padding: "10px"
                                                        }}>Medicine</TableCell>
                                                    <TableCell sx={{ width: '30%' }} align="center"
                                                        style={{
                                                            fontFamily: "'Poppins', sans-serif",
                                                            fontWeight: 500,
                                                            color: "black",
                                                            fontSize: "16px",
                                                            padding: "10px"
                                                        }}>Dose</TableCell>

                                                    <TableCell sx={{ width: '30%' }} align="center"
                                                        style={{
                                                            fontFamily: "'Poppins', sans-serif",
                                                            fontWeight: 500,
                                                            color: "black",
                                                            fontSize: "16px",
                                                            padding: "10px"
                                                        }}>Duration</TableCell>

                                                    <TableCell sx={{ width: '10%' }} align="center"></TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody style={{ backgroundColor: "#F8F8F4" }}>
                                                {prescriptionOneData?.currentDrugs?.map((e, i) => (
                                                    <TableRow key={i}>
                                                        <TableCell component="th" scope="row" sx={{ width: '30%' }} align="center">
                                                            <p style={{
                                                                fontFamily: "'Poppins', sans-serif",
                                                                fontWeight: 500,
                                                                color: "black",
                                                                fontSize: "16px",
                                                            }}>{e?.medicine}</p>
                                                        </TableCell>
                                                        <TableCell component="th" scope="row" sx={{ width: '30%' }} align="center">
                                                            <p style={{
                                                                fontFamily: "'Poppins', sans-serif",
                                                                fontWeight: 500,
                                                                color: "black",
                                                                fontSize: "16px",
                                                            }}>{e?.dose}</p>
                                                        </TableCell>

                                                        <TableCell align="center" sx={{ width: '30%' }}>
                                                            <p style={{
                                                                fontFamily: "'Poppins', sans-serif",
                                                                fontWeight: 500,
                                                                color: "black",
                                                                fontSize: "16px",
                                                            }}>{e?.duration}</p>
                                                        </TableCell>


                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </div>
                            </div>
                        )}

                        {(prescriptionOneData?.AI_Reports?.length > 0 || aiParameters?.length > 0) && (
                            <div>
                                <p className="Prescription-sh-h">AI Reports</p>
                                <div style={{ padding: '1rem' }}>
                                    <TableContainer>
                                        <Table aria-label="lab results table">
                                            <TableHead style={{ backgroundColor: "#D4CEC3" }}>
                                                <TableRow>
                                                    <TableCell align="center" style={{ ...headerStyle, width: '15%' }}>Name</TableCell>
                                                    <TableCell align="center" style={{ ...headerStyle, width: '10%' }}>Value</TableCell>
                                                    <TableCell align="center" style={{ ...headerStyle, width: '15%' }}>Reference Range</TableCell>
                                                    <TableCell align="center" style={{ ...headerStyle, width: '15%' }}>Status</TableCell>
                                                    <TableCell align="center" style={{ ...headerStyle, width: '35%' }}>Remarks</TableCell>
                                                    <TableCell align="center" style={{ ...headerStyle, width: '10%' }}>Goal</TableCell>

                                                </TableRow>
                                            </TableHead>
                                            <TableBody style={{ backgroundColor: "#F8F8F4" }}>
                                                {(prescriptionOneData?.AI_Reports?.length > 0 ? prescriptionOneData.AI_Reports : aiParameters).map((item, index) => (
                                                    <TableRow key={index}>
                                                        <TableCell align="center" style={cellStyle}>{item.name}</TableCell>
                                                        <TableCell align="center" style={cellStyle}>{item.value}</TableCell>
                                                        <TableCell align="center" style={cellStyle}>{item.reference_range}</TableCell>
                                                        <TableCell align="center">
                                                            <div style={{
                                                                display: 'inline-block',
                                                                padding: '4px 12px',
                                                                borderRadius: '16px',
                                                                fontSize: '13px',
                                                                fontWeight: 600,
                                                                textTransform: 'capitalize',
                                                                ...(() => {
                                                                    const s = (item.status || "").toLowerCase();
                                                                    if (s === "normal") return { color: "#1b5e20", backgroundColor: "#e8f5e9", border: "1px solid #c8e6c9" };
                                                                    if (s === "high" || s === "critical" || s === "abnormal") return { color: "#c62828", backgroundColor: "#ffebee", border: "1px solid #ffcdd2" };
                                                                    if (s === "low") return { color: "#e65100", backgroundColor: "#fff3e0", border: "1px solid #ffe0b2" };
                                                                    if (s === "borderline") return { color: "#f57c00", backgroundColor: "#fff3e0", border: "1px solid #ffe0b2" };
                                                                    return { color: "black", backgroundColor: "#f5f5f5", border: "1px solid #e0e0e0" };
                                                                })()
                                                            }}>
                                                                {item.status}
                                                            </div>
                                                        </TableCell>
                                                        <TableCell align="left" style={{ ...cellStyle, fontSize: '14px' }}>
                                                            {item.reason}
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            <input
                                                                type="checkbox"
                                                                checked={item?.goal}
                                                                readOnly
                                                                onClick={(e) => e.preventDefault()}
                                                                style={{
                                                                    width: '16px',
                                                                    height: '16px',
                                                                    accentColor: '#DA6E0B',
                                                                    cursor: 'default',
                                                                }}
                                                            />
                                                        </TableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </div>
                            </div>
                        )}

                        {
                            prescriptionOneData?.AyurvedaParameters &&
                            prescriptionOneData?.AyurvedaParameters.length > 0 &&
                            prescriptionOneData?.AyurvedaParameters.some(p => p.value?.trim() !== "") &&

                            <div>
                                <p className="Prescription-sh-h" style={{ color: 'black' }}>Ayurveda Parameters</p>

                                <ul className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-6">
                                    {prescriptionOneData?.AyurvedaParameters?.map((e, i) => {
                                        const key = e?.parameter ?? i;

                                        return (
                                            <li key={key} className="text-sm" style={{ color: 'black' }}>
                                                <div className="flex items-start justify-between gap-2">
                                                    <div>
                                                        <strong>{e?.parameter}</strong>: {e?.value || "Not assessed"}
                                                        {e?.reason && (
                                                            <span className="block text-xs text-black">
                                                                Reason: {e.reason}
                                                            </span>
                                                        )}
                                                    </div>

                                                    {e?.value && (
                                                        <span className="shrink-0 px-2 py-0.5 rounded bg-green-100 text-green-800 text-xs font-semibold">
                                                            {e.value}
                                                        </span>
                                                    )}
                                                </div>

                                                {Array.isArray(e?.questions) && e.questions.length > 0 && (
                                                    <div className="mt-2 rounded border border-[#D3D3D3] bg-[#F8F8F4] p-3 space-y-2">
                                                        {e.questions.map((q, idx) => {
                                                            // get the selected option’s display text for neat rendering
                                                            const selectedOption =
                                                                q?.options?.find((o) => o.value === q?.answer) || null;

                                                            return (
                                                                <div
                                                                    key={q?.id ?? `${e?.parameter}-${idx}`}
                                                                    className="pb-2 border-b border-[#E5E5E5] last:border-b-0 last:pb-0"
                                                                >
                                                                    <p className="text-black font-medium" style={{ color: 'black' }}>
                                                                        {idx + 1}. {q?.text}
                                                                    </p>

                                                                    <div className="mt-1 flex items-start gap-2">
                                                                        <span className="text-xs uppercase text-black leading-6" style={{ color: 'black' }}>
                                                                            Answer:
                                                                        </span>

                                                                        {selectedOption ? (
                                                                            <div className="flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-2">
                                                                                {/* Chosen value badge */}
                                                                                <span className="inline-flex px-2 py-0.5 rounded bg-blue-50 text-blue-800 text-xs font-semibold">
                                                                                    {selectedOption.value}
                                                                                </span>
                                                                                {/* Option descriptive text */}
                                                                                <span className="text-black" style={{ color: 'black' }}>
                                                                                    {selectedOption.text}
                                                                                </span>
                                                                            </div>
                                                                        ) : (
                                                                            <span className="text-black" style={{ color: 'black' }}>Not answered</span>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            );
                                                        })}
                                                    </div>
                                                )}
                                            </li>
                                        );
                                    })}
                                </ul>
                            </div>

                        }



                        {
                            prescriptionOneData?.VitalSigns &&
                            Object.values(prescriptionOneData.VitalSigns).some(val => val?.trim?.() !== "") && (
                                <div className="mt-5">
                                    <p className="Prescription-sh-h">Vital Signs</p>
                                    <div className="Medical-details-div">
                                        {Object.entries(prescriptionOneData.VitalSigns)
                                            .filter(([key, value]) => key !== "bloodSugarType" && value?.trim?.() !== "")
                                            .map(([key, value]) => {
                                                const meta = vitalSignMeta[key] || { label: key, unit: "" };


                                                if (key === "randomBloodSugar") {
                                                    const sugarType = prescriptionOneData.VitalSigns.bloodSugarType;
                                                    const suffix = sugarType ? ` (${sugarType})` : "(Random)";
                                                    return (
                                                        <div key={key} className="flex items-center gap-2 mb-2">
                                                            <p style={{ fontWeight: 500 }}>{meta.label}:</p>
                                                            <p>{value} {meta.unit}{suffix}</p>
                                                        </div>
                                                    );
                                                }

                                                return (
                                                    <div key={key} className="flex items-center gap-2 mb-2">
                                                        <p style={{ fontWeight: 500 }}>{meta.label}:</p>
                                                        <p>{value} {meta.unit}</p>
                                                    </div>
                                                );
                                            })}
                                    </div>
                                </div>
                            )
                        }

                        {prescriptionOneData?.Medical_details &&
                            Object?.values(prescriptionOneData?.Medical_details)?.some(val => val.trim() !== "") &&
                            < div >
                                <p className="Prescription-sh-h">Diagnosis</p>
                                <div className="Medical-details-div">
                                    {prescriptionOneData?.Medical_details?.ayurvedadiagnosis && <div className='flex items-center gap-2'>
                                        <p>Ayurveda Diagnosis:</p>
                                        <p>{prescriptionOneData?.Medical_details?.ayurvedadiagnosis}</p>
                                    </div>}
                                    {prescriptionOneData?.Medical_details?.moderndiagnosis && <div className='flex items-center gap-2'>
                                        <p>Modern Diagnosis:</p>
                                        <p>{prescriptionOneData?.Medical_details?.moderndiagnosis}</p>
                                    </div>}
                                    {prescriptionOneData?.Medical_details?.Complaints && <div className='flex items-center gap-2'>
                                        <p>Complaints:</p>
                                        <p>{prescriptionOneData?.Medical_details?.Complaints}</p>
                                    </div>}
                                    {prescriptionOneData?.Medical_details?.lab && <div className='flex items-center gap-2'>
                                        <p>Examination / Lab findings:</p>
                                        <p>{prescriptionOneData?.Medical_details?.lab}</p>
                                    </div>}
                                    {prescriptionOneData?.Medical_details?.history && <div className='flex items-center gap-2'>
                                        <p>Medical History:</p>
                                        <p>{prescriptionOneData?.Medical_details?.history}</p>
                                    </div>}
                                    {prescriptionOneData?.Medical_details?.diagnosis && <div className='flex items-center gap-2'>
                                        <p>Diagnosis:</p>
                                        <p>{prescriptionOneData?.Medical_details?.diagnosis}</p>
                                    </div>}
                                </div>
                            </div>
                        }


                        <div className="flex items-stretch w-full gap-5">

                            {prescriptionOneData?.PrakritiDetails && Object.keys(prescriptionOneData?.PrakritiDetails).length > 0 && (
                                <div className="mt-4 flex-1 flex flex-col">
                                    <p className="Prescription-sh-h" style={{ color: 'black' }}>Prakriti Details</p>
                                    <div className="bg-gray-50 border p-4 rounded-md shadow-sm text-sm flex-1">
                                        <ul className="list-disc list-inside">
                                            <li style={{ color: 'black' }}><strong>Vata:</strong> {Math.ceil(prescriptionOneData.PrakritiDetails.vata)}%</li>
                                            <li style={{ color: 'black' }}><strong>Pitta:</strong> {Math.ceil(prescriptionOneData.PrakritiDetails.pitta)}%</li>
                                            <li style={{ color: 'black' }}><strong>Kapha:</strong> {Math.ceil(prescriptionOneData.PrakritiDetails.kapha)}%</li>
                                            <div className="mt-5" style={{ color: 'black' }}>
                                                <strong>Prakriti Result:</strong>{" "}
                                                {prescriptionOneData.PrakritiDetails.result
                                                    ?.split("")
                                                    ?.map((char) => doshaMap[char])
                                                    ?.join(" ")}
                                            </div>
                                        </ul>
                                    </div>
                                </div>
                            )}

                            {prescriptionOneData?.VikritiDetails &&
                                !isDoshamEmpty(prescriptionOneData?.VikritiDetails) && (
                                    <div className="mt-4 flex-1 flex flex-col">
                                        <p className="Prescription-sh-h" style={{ color: 'black' }}>Vikriti Details</p>
                                        <div className="bg-gray-50 border p-4 rounded-md shadow-sm text-sm flex-1" style={{ color: 'black' }}>
                                            <ul className="list-disc list-inside">
                                                {prescriptionOneData.VikritiDetails.Increased?.doshas?.length > 0 && (
                                                    <>
                                                        <div className="font-semibold">Increased Doshas:</div>
                                                        {prescriptionOneData.VikritiDetails.Increased.doshas.map((dosha) => (
                                                            <li key={`inc-${dosha}`} className="ml-4 capitalize">
                                                                <strong>{dosha.charAt(0).toUpperCase() + dosha.slice(1)}:</strong>{" "}
                                                                {prescriptionOneData.VikritiDetails.Increased.percentage?.[dosha]
                                                                    ? `${prescriptionOneData.VikritiDetails.Increased.percentage[dosha]}%`
                                                                    : "—"}
                                                                {prescriptionOneData.VikritiDetails.Increased.intensity?.[dosha]
                                                                    ? ` (${prescriptionOneData.VikritiDetails.Increased.intensity[dosha]})`
                                                                    : ""}
                                                            </li>
                                                        ))}
                                                    </>
                                                )}

                                                {prescriptionOneData.VikritiDetails.Decreased?.doshas?.length > 0 && (
                                                    <>
                                                        <div className="font-semibold mt-3">Decreased Doshas:</div>
                                                        {prescriptionOneData.VikritiDetails.Decreased.doshas.map((dosha) => (
                                                            <li key={`dec-${dosha}`} className="ml-4 capitalize">
                                                                <strong>{dosha.charAt(0).toUpperCase() + dosha.slice(1)}:</strong>{" "}

                                                                {prescriptionOneData.VikritiDetails.Decreased.percentage?.[dosha]
                                                                    ? `-${prescriptionOneData.VikritiDetails.Decreased.percentage[dosha]}%`
                                                                    : "—"
                                                                }

                                                                {prescriptionOneData.VikritiDetails.Decreased.intensity?.[dosha]
                                                                    ? ` (${prescriptionOneData.VikritiDetails.Decreased.intensity[dosha]})`
                                                                    : ""
                                                                }

                                                            </li>
                                                        ))}
                                                    </>
                                                )}

                                                {prescriptionOneData.VikritiDetails.Increased?.doshas?.length > 0 && (
                                                    <div className="mt-5">
                                                        <strong>Vikriti Result:</strong>{" "}
                                                        {prescriptionOneData.VikritiDetails.Increased.doshas
                                                            .map((d) => doshaMap[d.charAt(0).toUpperCase()])
                                                            .join(" ")}
                                                    </div>
                                                )}

                                                {prescriptionOneData.VikritiDetails.Increased?.doshas?.length > 0 && (
                                                    <div className="mt-5">
                                                        <strong>Reason:</strong>{" "}
                                                        {prescriptionOneData?.VikritiDetails?.Reason}
                                                    </div>
                                                )}

                                            </ul>
                                        </div>
                                    </div>
                                )}

                        </div>

                        {
                            prescriptionOneData?.labTests &&
                            prescriptionOneData?.labTests?.length > 0 && < div >
                                <p className="Prescription-sh-h" style={{ color: 'black' }}>Lab Tests</p>
                                <div className='labtestlist'>
                                    {
                                        prescriptionOneData?.labTests.map((e, i) => {
                                            return <div className='labtestitem'>
                                                <p style={{ color: 'black' }}>{e}</p>
                                            </div>
                                        })
                                    }
                                </div>
                            </div>
                        }

                        {prescriptionOneData?.Supplements &&
                            prescriptionOneData?.Supplements.some(e => e?.id != '') &&
                            <div>
                                <p className="Prescription-sh-h">Medicines</p>
                                <div className='Supplement-medicine-card-container'>
                                    {prescriptionOneData?.Supplements &&
                                        prescriptionOneData?.Supplements.filter(e => e?.id !== '')?.map((e, i) => {
                                            return <div className='Supplement-medicine-card' onClick={() => {
                                                e.id != '' &&
                                                    window.open(`https://www.app.aiwell.in/Product?id=${e.id}`)
                                            }}>
                                                <div className='flex flex-row gap-10'>

                                                    <div className='Supplement-medicine-card-image'>

                                                        {e.id != '' ?
                                                            <img src={e?.imgurl || e?.img} alt="Medicine Image" ></img>
                                                            :
                                                            <img src="https://aiwellassets.s3.ap-south-1.amazonaws.com/Product+place+holder.png" alt="Medicine Image" />
                                                        }

                                                    </div>

                                                    <div className='Supplement-medicine-card-info'>
                                                        <p>{e.medicine}</p>

                                                        <div>
                                                            <p><span>Dose</span>: {e?.dose}</p>
                                                            <p><span>Order Quantity</span>: {e?.quantity}</p>
                                                            <p><span>Duration</span> : {e?.duration}</p>
                                                            {e?.takeFood && <p><span>Take Medicine</span> : {e?.takeFood}</p>}
                                                            <p><span>Timing</span> : {e?.timing}</p>
                                                            <p><span>Instruction</span> : {e?.instruction}</p>
                                                        </div>

                                                    </div>

                                                </div>

                                                {e.id === '' && <p style={{ fontSize: "8px" }}>
                                                    This product is not available on our platform.</p>}

                                            </div>
                                        })
                                    }
                                </div>
                            </div>
                        }

                        {prescriptionOneData?.Supplements &&
                            prescriptionOneData?.Supplements.some(e => e?.id === '') ?
                            <div>
                                <p className="Prescription-sh-h">Other Medicines</p>
                                <div className='Supplement-medicine-card-container'>
                                    {prescriptionOneData?.Supplements &&
                                        prescriptionOneData?.Supplements.filter(e => e?.id === '')?.map((e, i) => {
                                            return <div className='Supplement-medicine-card'>
                                                <div className='flex flex-row gap-10'>

                                                    <div className='Supplement-medicine-card-image'>
                                                        {e.id != '' ?
                                                            <img src={e?.imgurl || e?.img} alt="Medicine Image" ></img>
                                                            :
                                                            <img src="https://aiwellassets.s3.ap-south-1.amazonaws.com/Product+place+holder.png" alt="Medicine Image" />
                                                        }
                                                    </div>

                                                    <div className='Supplement-medicine-card-info'>
                                                        <p>{e.medicine}</p>
                                                        <div>
                                                            <p><span>Dose</span>: {e?.dose}</p>
                                                            <p><span>Order Quantity</span>: {e?.quantity}</p>
                                                            <p><span>Duration</span> : {e?.duration}</p>
                                                            {e?.takeFood && <p><span>Take Medicine</span> : {e?.takeFood}</p>}
                                                            <p><span>Timing</span> : {e?.timing}</p>
                                                            <p><span>Instruction</span> : {e?.instruction}</p>
                                                            <p><span>Product Link</span> : {e?.productlink}</p>
                                                            <p><span>Reason</span> : {e?.reason}</p>
                                                        </div>

                                                    </div>

                                                </div>

                                                <p style={{ fontSize: "8px" }}>This product is not available on our platform.</p>

                                            </div>
                                        })
                                    }
                                </div>

                            </div> : <></>
                        }

                        {prescriptionOneData?.Diet?.included?.length > 0 ||
                            prescriptionOneData?.Diet?.avoided?.length > 0 ? (
                            <div className="after-page-break">
                                <p className="Prescription-sh-h" style={{ color: 'black' }}>Diet</p>
                                <div className="container">

                                    {prescriptionOneData?.Diet?.included?.length > 0 && (
                                        <div className="card">
                                            <div className="card-header p-2 gap-5">
                                                <div className="icon">✅</div>
                                                <p style={{ color: 'black' }}>Food to be Included</p>
                                            </div>
                                            <div className="card-content">
                                                {prescriptionOneData?.Diet?.included?.map(
                                                    (e, i) => (
                                                        <div key={i}>
                                                            <img
                                                                src={e?.imageLink || 'https://aiwellassets.s3.ap-south-1.amazonaws.com/icons/appicons/recipeplaceholder.png'}
                                                                alt={e?.englishName}
                                                                onError={(e) => {
                                                                    e.target.onerror = null;
                                                                    e.target.src = 'https://aiwellassets.s3.ap-south-1.amazonaws.com/icons/appicons/recipeplaceholder.png';
                                                                }}
                                                            />
                                                            <p style={{ color: 'black' }}>{e?.englishName}</p>
                                                        </div>
                                                    )
                                                )}
                                            </div>
                                        </div>
                                    )}

                                    {prescriptionOneData?.Diet?.avoided?.length > 0 && (
                                        <div className="card">
                                            <div className="card-header p-2 gap-5">
                                                <div className="icon">❌</div>
                                                <p style={{ color: 'black' }}>Food to be Minimal</p>
                                            </div>
                                            <div className="card-content">
                                                {prescriptionOneData?.Diet?.avoided?.map(
                                                    (e, i) => (
                                                        <div key={i}>
                                                            <img
                                                                src={e?.imageLink || 'https://aiwellassets.s3.ap-south-1.amazonaws.com/icons/appicons/recipeplaceholder.png'}
                                                                alt={e?.englishName}
                                                                onError={(e) => {
                                                                    e.target.onerror = null;
                                                                    e.target.src = 'https://aiwellassets.s3.ap-south-1.amazonaws.com/icons/appicons/recipeplaceholder.png';
                                                                }}
                                                            />
                                                            <p style={{ color: 'black' }}>{e?.englishName}</p>
                                                        </div>
                                                    )
                                                )}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        ) : null}

                        {prescriptionOneData?.Recipes?.length > 0 && (
                            <div className="after-page-break">
                                <p className="Prescription-sh-h" style={{ color: 'black' }}>Recipes</p>

                                <div className="space-y-4">
                                    {MEAL_ORDER.map((key) => {
                                        const items = groupedRecipes[key];
                                        if (!items.length) return null;

                                        return (
                                            <section key={key} className="rounded-xl border-2 p-3 shadow-sm w-full overflow-hidden">
                                                <div className="mb-2 flex items-baseline justify-between">
                                                    <h4 className="text-sm font-semibold" style={{ color: 'black' }}>{MEAL_LABELS[key]}</h4>
                                                    <span className="text-xs text-black" style={{ color: 'black' }}>
                                                        {items.length} item{items.length !== 1 ? "s" : ""}
                                                    </span>
                                                </div>

                                                <div className="item-container grid grid-cols-2 gap-5 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 w-full place-items-center">
                                                    {items.map((r, i) => (
                                                        <div
                                                            key={i}
                                                            className="flex flex-col items-center gap-4 w-full  justify-center "
                                                        >
                                                            <div className="w-[100px] h-[100px] flex justify-center items-center">
                                                                <img
                                                                    src={r?.imageLink}
                                                                    alt={r?.recipe}
                                                                    className="w-full h-full object-cover rounded-full border border-gray-300 shadow"
                                                                />
                                                            </div>
                                                            <div className="w-full  text-center">
                                                                {/* <h2 className="text-2xl font-bold mb-3">{r?.recipe}</h2> */}
                                                                <p className="text-sm" style={{ color: 'black' }}>{r?.recipe}</p>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </section>
                                        );
                                    })}
                                </div>
                            </div>
                        )}

                        {(
                            prescriptionOneData?.Practices?.yoga?.length > 0 ||
                            prescriptionOneData?.Practices?.pranayama?.length > 0 ||
                            prescriptionOneData?.Practices?.meditation?.length > 0
                        ) && (
                                <div className="mt-5">
                                    <p className="Prescription-sh-h">LifeStyle Practices</p>
                                </div>
                            )}

                        <div className="lifestyle-container">

                            {prescriptionOneData?.Practices?.yoga?.length > 0 && (
                                <div className="lifestyle-card">
                                    <div className="lifestyle-card-header">Yoga</div>
                                    <div className="lifestyle-card-content">
                                        <ul className="list-none">
                                            {prescriptionOneData?.Practices?.yoga?.map((e, i) => (
                                                <li
                                                    key={i}
                                                    onClick={() => navigate(`/Yoga?id=${e?.id}`)}
                                                    className="flex items-center justify-between mt-4 gap-2 cursor-pointer"
                                                >
                                                    <span className="whitespace-nowrap">{e.title}</span>
                                                    <div className="flex-1 border-t-2 border-dashed border-[#a5a39d] mx-4"></div>
                                                    {e.reps ? (
                                                        <span className="whitespace-nowrap text-sm">{e.reps} reps</span>
                                                    ) : null}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            )}

                            {prescriptionOneData?.Practices?.pranayama?.length > 0 && (
                                <div className="lifestyle-card">
                                    <div className="lifestyle-card-header">Pranayama</div>
                                    <div className="lifestyle-card-content">
                                        <ul className="list-none">
                                            {prescriptionOneData?.Practices?.pranayama?.map((e, i) => (
                                                <li
                                                    key={i}
                                                    onClick={() => navigate(`/Pranayama?id=${e?.id}`)}
                                                    className="flex items-center justify-between mt-4 gap-2 cursor-pointer"
                                                >
                                                    <span className="whitespace-nowrap">{e.title}</span>
                                                    <div className="flex-1 border-t-2 border-dashed border-[#a5a39d] mx-4"></div>
                                                    {e.reps ? (
                                                        <span className="whitespace-nowrap text-sm">{e.reps} reps</span>
                                                    ) : null}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            )}

                            {prescriptionOneData?.Practices?.meditation?.length > 0 && (
                                <div className="lifestyle-card">
                                    <div className="lifestyle-card-header">Meditation</div>
                                    <div className="lifestyle-card-content">
                                        <ul className="list-none">
                                            {prescriptionOneData?.Practices?.meditation?.map((e, i) => (
                                                <li
                                                    key={i}
                                                    onClick={() => navigate(`/Meditation?id=${e?.Id}`)}
                                                    className="flex items-center justify-between mt-4 gap-2 cursor-pointer"
                                                >
                                                    <span className="whitespace-nowrap">{e.title}</span>
                                                    <div className="flex-1 border-t-2 border-dashed border-[#a5a39d] mx-4"></div>
                                                    {e.duration ? (
                                                        <span className="whitespace-nowrap text-sm">{e.duration} min</span>
                                                    ) : null}
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            )}


                        </div>

                        {/* {prescriptionOneData?.LifeStyle_changes?.length > 0 && (
                            <div className="after-page-break">
                                <p className="Prescription-sh-h">Lifestyle Changes</p>
                                <div className="LifeStyle-changes-Container">
                                    <ul>
                                        {prescriptionOneData.LifeStyle_changes.map((item, index) => {
                                            const trimmed = item.trim();
                                            const capitalized = trimmed.charAt(0).toUpperCase() + trimmed.slice(1);
                                            const formatted = capitalized.endsWith(".") ? capitalized : capitalized + ".";

                                            return <li key={index}>{formatted}</li>;
                                        })}
                                    </ul>
                                </div>
                            </div>
                        )} */}

                        {prescriptionOneData?.LifeStyle_changes?.length > 0 && (
                            <div className="after-page-break w-full">
                                <p className="Prescription-sh-h">Lifestyle Changes</p>

                                <div className="LifeStyle-changes-Container w-full">
                                    <ul className='list-disc list-inside w-full'>
                                        {prescriptionOneData.LifeStyle_changes.map((item, index) => {
                                            const trimmed = item.trim();
                                            const capitalized = trimmed.charAt(0).toUpperCase() + trimmed.slice(1);
                                            const formatted = capitalized.endsWith(".") ? capitalized : capitalized + ".";

                                            return <li key={index}>{formatted}</li>;
                                        })}
                                    </ul>
                                </div>
                            </div>
                        )}



                        {prescriptionOneData?.Follow_up && (
                            <div className="after-page-break">
                                <p className="Prescription-sh-h">Follow up Date</p>
                                <div className="LifeStyle-changes-Container">
                                    <p style={{ color: 'black' }}>{prescriptionOneData?.Follow_up}</p>
                                </div>
                            </div>
                        )}

                        <div className='flex flex-row items-center justify-center mt-10 mb-10'>
                            <div className='prescription-buy-now'>
                                <Button
                                    style={{
                                        width: '100%',
                                        textTransform: 'none',
                                        borderRadius: '0',
                                        backgroundColor: '#DA6E0B',
                                        color: 'white',
                                        border: 'none',
                                        boxSizing: 'border-box',
                                        borderRadius: '5px',
                                        fontFamily: "'Poppins', sans-serif",
                                        fontWeight: 500,
                                        padding: '10px'
                                    }}

                                    onClick={() => handleDownload(prescriptionOneData?.Prescription, prescriptionOneData?.Patient_details?.firstname)}
                                >
                                    <DownloadIcon />&nbsp; Download Prescription
                                </Button>
                            </div>

                        </div>

                    </div>
                </div>
            </div>
        </div>

    </div>

}

export default ViewPrescription

